import * as actionTypes from './actionTypes';
import API from '../../axios/api';
import { toastr } from 'react-redux-toastr'
import axios from 'axios';
import { i18n } from '../../translate/i18n';
import siteObjectToQuery from '../../utils/siteObjectToQuery';
import usersObjectToQuery from '../../utils/usersObjectToQuery';
import statusObjectToQuery from '../../utils/statusObjectToQuery';
import equipmentsObjetctToQuery from '../../utils/equipmentsObjectToQuery';
import filterObjectToQuery from '../../utils/filterObjectToQuery';
let CancelToken = axios.CancelToken;
let fetchMaintenances_cancel;
let fetchMaintenanceById_cancel;
let fetchMaintenancesExport_cancel;

export const requestMaintenanceStart = () => {
  return {
    type: actionTypes.REQUEST_MAINTENANCE_START,
  };
};

export const postMaintenanceSuccess = (maintenance) => {
  return {
    type: actionTypes.POST_MAINTENANCE_SUCCESS,
    maintenance,
  }
}

export const requestMaintenanceFail = (error) => {
  return {
    type: actionTypes.REQUEST_MAINTENANCE_FAIL,
    error: error
  };
};

export const setMaintenancesFilter = (page, limit, searchText, order, orderBy) => {
  return {
    type: actionTypes.SET_MAINTENANCES_FILTER,
    maintenancesFilter: {
      page, limit, searchText, order, orderBy,
    }
  };
};

export const postMaintenance = (body) => {
  return dispatch => {
    return new Promise((resolve, reject) => {

      dispatch(requestMaintenanceStart());
      API.post('/maintenances', body)
        .then(res => {
          dispatch(postMaintenanceSuccess(res.data));
          toastr.success(i18n.t('maintenanceMessages.post'))
          resolve('success');
        })
        .catch(err => {
          dispatch(requestMaintenanceFail(err));
        });
    })

  }
}

//fetch Maintenances
export const fetchMaintenancesByEquipmentStart = () => {
  return {
    type: actionTypes.FETCH_MAINTENANCES_BY_EQUIPMENT_START,
  };
};

export const fetchMaintenancesByEquipmentFail = (error) => {
  return {
    type: actionTypes.FETCH_MAINTENANCES_BY_EQUIPMENT_FAIL,
  };
};

export const fetchMaintenancesByEquipmentInfiniteScrollStart = () => {
  return {
    type: actionTypes.FETCH_MAINTENANCES_BY_EQUIPMENT_INFINITE_SCROLL_START,
  };
};

export const fetchMaintenancesByEquipmentInfinteScrollSuccess = (maintenances) => {
  return {
    type: actionTypes.FETCH_MAINTENANCES_BY_EQUIPMENT_INFINITE_SCROLL_SUCCESS,
    maintenances,
  };
};

export const fetchMaintenancesByEquipmentSuccess = (timelineMaintenances) => {
  return {
    type: actionTypes.FETCH_MAINTENANCES_BY_EQUIPMENT_SUCCESS,
    timelineMaintenances,
  };
};

export const fetchMaintenanceByIdSuccess = (maintenance) => {
  return {
    type: actionTypes.FETCH_MAINTENANCE_BY_ID_SUCCESS,
    maintenance,
  };
}

export const fetchMaintenancesByEquipment = (page, limit, search, order, orderBy, infiniteScroll, equipmentId, sites, filteredEquipments, filteredcreatedAt, filteredSendToMaintenanceDate, filteredReturnFromMaintenanceDate, filteredWarranty, filteredExpiration, filteredPlaces, filteredStatusMaintenances) => {
  return dispatch => {
    return new Promise((resolve, reject) => {
      // dispatch(setMaintenancesFilter(page, limit, search, order, orderBy));
      if (!infiniteScroll) {
        dispatch(fetchMaintenancesByEquipmentStart());
      } else {
        dispatch(fetchMaintenancesByEquipmentInfiniteScrollStart());
      }

      let queryParams = `?page=${!page || page < 1 ? 1 : page}&limit=${!limit || limit < 5 ? 5 : limit}&q=${search ? search : ''}&sort=${order === 'desc' ? '-' : ''}${orderBy}`;
      queryParams += `${equipmentId ? '&equipment=' + equipmentId : ''}`
      queryParams += `${sites && sites.length > 0 ? '&sites=' + siteObjectToQuery(sites) : ''}`
      queryParams += `${filteredEquipments && filteredEquipments.length > 0 ? `&equipmentModel=${equipmentsObjetctToQuery(filteredEquipments)}` : ''}`
      queryParams += `${filteredPlaces && filteredPlaces.length > 0 ? '&leafs=' + filterObjectToQuery(filteredPlaces) : ''}`
      queryParams += `${filteredcreatedAt ? `&createdAt=${filteredcreatedAt.toISOString()}` : ''}`
      queryParams += `${filteredSendToMaintenanceDate ? `&sendToMaintenanceDate=${filteredSendToMaintenanceDate.toISOString()}` : ''}`
      queryParams += `${filteredReturnFromMaintenanceDate ? `&returnFromMaintenanceDate=${filteredReturnFromMaintenanceDate.toISOString()}` : ''}`
      queryParams += `${filteredWarranty ? `&warranty=${filteredWarranty.toISOString()}` : ''}`
      queryParams += `${filteredExpiration ? `&expiration=${filteredExpiration.toISOString()}` : ''}`
      queryParams += `${filteredStatusMaintenances && filteredStatusMaintenances.length > 0 ? `&statusMaintenances=${filterObjectToQuery(filteredStatusMaintenances)}` : ''}`;

      API.get('/maintenances' + queryParams)
        .then(res => {
          dispatch(fetchMaintenancesSuccess(res.data));

          if(!infiniteScroll) {
            dispatch(fetchMaintenancesByEquipmentSuccess(res.data));
          } else {
            dispatch(fetchMaintenancesByEquipmentInfinteScrollSuccess(res.data));
          }
          resolve(res.data);
        })
        .catch(err => {
          dispatch(fetchMaintenancesByEquipmentFail(err));
          resolve('error', err.message);
        });
    })
  }
};

// fetch MaintenanceById
export const fetchMaintenanceById = (id) => {
  fetchMaintenanceById_cancel && fetchMaintenanceById_cancel()
  return dispatch => {
    dispatch(requestMaintenanceStart());
    API.get('/maintenances/' + id, {
      cancelToken: new CancelToken(function executor(c) {
        fetchMaintenanceById_cancel = c;
      })
    })
      .then(res => {
        dispatch(fetchMaintenanceByIdSuccess(res.data));
      })
      .catch(err => {
        dispatch(requestMaintenanceFail(err));
      });
  };
};

// update Maintenance
export const updateMaintenanceSuccess = (maintenance) => {
  return {
    type: actionTypes.UPDATE_MAINTENANCE_SUCCESS,
    maintenance,
  }
}

export const updateMaintenance = (index, body) => {
  return dispatch => {
    return new Promise((resolve, reject) => {

      dispatch(requestMaintenanceStart());
      API.put('/maintenances/' + index, body)
        .then(res => {
          dispatch(updateMaintenanceSuccess());
          toastr.success(i18n.t('maintenanceMessages.update'))
          dispatch(fetchMaintenanceById(index))
          resolve('success');
        })
        .catch(err => {
          dispatch(requestMaintenanceFail(err));
          resolve('error', err.message);
        });
    })
  }
}

// delete Maintenance
export const deleteMaintenanceSuccess = (action) => {
  return {
    type: actionTypes.DELETE_MAINTENANCE_SUCCESS,
    action,
  }
};

export const deleteMaintenance = (index) => {
  return dispatch => {
    return new Promise((resolve, reject) => {

      dispatch(requestMaintenanceStart());
      API.patch('/maintenances/' + index + '/delete')
        .then(res => {
          dispatch(deleteMaintenanceSuccess(res.data));
          toastr.success(i18n.t('maintenanceMessages.delete'))
          resolve('success');
        })
        .catch(err => {
          dispatch(requestMaintenanceFail(err));
          resolve('error', err.message);
        });
    })
  }
}

// add message To Timeline
export const addMessageTimelineMaintenance = (index, body) => {
  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch(requestMaintenanceStart());
      API.patch('/maintenances/' + index + '/add_message/', body)
        .then(res => {
          dispatch(updateMaintenanceSuccess());
          toastr.success(i18n.t('maintenanceMessages.update'))
          dispatch(fetchMaintenanceById(index))
          resolve('success');
        })
        .catch(err => {
          dispatch(requestMaintenanceFail(err));
          toastr.error('Erro', err)
          reject('error');
        });
    })
  }
}

export const fetchMaintenancesExport = (search, order, orderBy, sites, filteredEquipments, filteredCreatedAt, filteredSendToMaintenanceDate, filteredReturnFromMaintenanceDate, filteredWarranty, filteredExpiration, filteredPlaces, filteredStatus, emailLanguage) => {
  fetchMaintenancesExport_cancel && fetchMaintenancesExport_cancel();
  return dispatch => {
    return new Promise((resolve, reject) => {
      let queryParams = `?q=${search ? search : ''}&sort=${order === 'desc' ? '-' : ''}${orderBy}`;
      queryParams += `${sites && sites.length > 0 ? '&sites=' + siteObjectToQuery(sites) : ''}`
      queryParams += `${filteredEquipments && filteredEquipments.length > 0 ? `&equipmentModel=${equipmentsObjetctToQuery(filteredEquipments)}` : ''}`
      queryParams += `${filteredCreatedAt ? `&createdAt=${filteredCreatedAt.toISOString()}` : ''}`
      queryParams += `${filteredSendToMaintenanceDate ? `&sendToMaintenanceDate=${filteredSendToMaintenanceDate.toISOString()}` : ''}`
      queryParams += `${filteredReturnFromMaintenanceDate ? `&returnFromMaintenanceDate=${filteredReturnFromMaintenanceDate.toISOString()}` : ''}`
      queryParams += `${filteredWarranty ? `&warranty=${filteredWarranty.toISOString()}` : ''}`
      queryParams += `${filteredExpiration ? `&expiration=${filteredExpiration.toISOString()}` : ''}`
      queryParams += `${filteredPlaces && filteredPlaces.length > 0 ? '&leafs=' + filterObjectToQuery(filteredPlaces) : ''}`
      queryParams += `${filteredStatus && filteredStatus.length > 0 ? `&statusMaintenances=${filterObjectToQuery(filteredStatus)}` : ''}`;
      queryParams += `${emailLanguage && emailLanguage.length > 0 ? `&emailLanguage=${emailLanguage}` : 'pt'}`;

      API.get('/maintenances/report' + queryParams, {
        cancelToken: new CancelToken(function executor(c) {
          fetchMaintenancesExport_cancel = c;
        })
      })
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          toastr.error('Erro', err)
          reject(err);
        });
    })
  };
};

export const fetchMaintenancesSuccess = (maintenances) => {
  return {
    type: actionTypes.FETCH_MAINTENANCES_SUCCESS,
    maintenances,
  };
};

export const clearMaintenanceInfo = () => {
  return {
    type: actionTypes.CLEAR_MAINTENANCE_INFO,
  };
};

export const filterMaintenanceEquipments = (equipments) => {
  return {
    type: actionTypes.FILTER_MAINTENANCE_EQUIPMENTS,
    equipments,
  };
};

export const filterMaintenanceEquipmentsRemove = (equipment) => {
  return {
    type: actionTypes.FILTER_MAINTENANCE_EQUIPMENTS_REMOVE,
    equipment,
  };
};

export const filterMaintenanceCreatedAt = (createdAt) => {
  return {
    type: actionTypes.FILTER_MAINTENANCE_CREATED_AT,
    createdAt,
  };
};

export const filterMaintenanceCreatedAtRemove = (createdAt) => {
  return {
    type: actionTypes.FILTER_MAINTENANCE_CREATED_AT_REMOVE,
    createdAt,
  };
};

export const filterMaintenanceSendToMaintenanceDate = (sendToMaintenanceDate) => {
  return {
    type: actionTypes.FILTER_MAINTENANCE_SEND_TO_MAINTENANCE_DATE,
    sendToMaintenanceDate,
  };
};

export const filterMaintenanceSendToMaintenanceDateRemove = (sendToMaintenanceDate) => {
  return {
    type: actionTypes.FILTER_MAINTENANCE_SEND_TO_MAINTENANCE_DATE_REMOVE,
    sendToMaintenanceDate,
  };
};

export const filterMaintenanceReturnFromMaintenanceDate = (returnFromMaintenanceDate) => {
  return {
    type: actionTypes.FILTER_MAINTENANCE_RETURN_FROM_MAINTENANCE_DATE,
    returnFromMaintenanceDate,
  };
};

export const filterMaintenanceReturnFromMaintenanceDateRemove = (returnFromMaintenanceDate) => {
  return {
    type: actionTypes.FILTER_MAINTENANCE_RETURN_FROM_MAINTENANCE_DATE_REMOVE,
    returnFromMaintenanceDate,
  };
};

export const filterMaintenanceWarranty = (warranty) => {
  return {
    type: actionTypes.FILTER_MAINTENANCE_WARRANTY,
    warranty,
  };
};

export const filterMaintenanceWarrantyRemove = (warranty) => {
  return {
    type: actionTypes.FILTER_MAINTENANCE_WARRANTY_REMOVE,
    warranty,
  };
};

export const filterMaintenanceExpiration = (expiration) => {
  return {
    type: actionTypes.FILTER_MAINTENANCE_EXPIRATION,
    expiration,
  };
};

export const filterMaintenanceExpirationRemove = (expiration) => {
  return {
    type: actionTypes.FILTER_MAINTENANCE_EXPIRATION_REMOVE,
    expiration,
  };
};

export const filterMaintenanceClear = () => {
  return {
    type: actionTypes.FILTER_MAINTENANCE_CLEAR,
  };
};

export const filterMaintenancePlaces = (places) => {
  return {
    type: actionTypes.FILTER_MAINTENANCE_PLACES,
    places,
  };
};

export const filterMaintenancePlacesRemove = (place) => {
  return {
    type: actionTypes.FILTER_MAINTENANCE_PLACES_REMOVE,
    place,
  };
};

export const filterMaintenanceStatus = (status) => {
  return {
    type: actionTypes.FILTER_MAINTENANCE_STATUS,
    status,
  };
};

export const filterMaintenanceStatusRemove = (status) => {
  return {
    type: actionTypes.FILTER_MAINTENANCE_STATUS_REMOVE,
    status,
  };
};
